import React from "react";

// Central helper so every icon renders the same way (and doesn't break pages expecting React nodes)
function IconImg({ src, alt }) {
  return (
    <img
      src={src}
      alt={alt}
      aria-hidden={alt ? undefined : true}
      loading="lazy"
      decoding="async"
      style={{
        width: "110px",
        height: "110px",
        paddingBottom: "20px",
        paddingTop: "20px",
        objectFit: "cover",
        display: "block",
        margin: "0 auto",
      }}
    />
  );
}

export const ICONS = {
  // NOTE: keep keys aligned with whatever your projects/categories page expects.
  // These keys match the ones that were already in your file.

  walkInShowers: (
    <IconImg
      src="/assets/icons/categories/icons-showers-walk-in-tubs.gif"
      alt="Showers / Walk-In Tubs"
    />
  ),

  walkInTubs: (
    <IconImg
      src="/assets/icons/categories/icons-showers-walk-in-tubs.gif"
      alt="Walk-In Tubs"
    />
  ),

  washersDryers: (
    <IconImg
      src="/assets/icons/categories/icons-washers-dryers.gif" 
      alt="Washers-Dryers"
    />
  ),

  stairlifts: (
    // If you don't have a stairlifts asset yet, keep the SVG or point to a placeholder.
    // Swap this path once you add it.
    <IconImg src="/assets/icons/categories/icons-showers-walk-in-tubs.gif" alt="Stairlifts" />
  ),

  windowReplacement: (
    <IconImg
      src="/assets/icons/categories/icons-windows-replacement.gif"
      alt="Windows & Doors"
    />
  ),

  gutterGuards: (
    <IconImg src="/assets/icons/categories/icons-rain-gutters.gif" alt="Rain Gutters" />
  ),

  roofing: <IconImg src="/assets/icons/categories/icons-roofing.gif" alt="Roofing" />,

  siding: (
    <IconImg
      src="/assets/icons/categories/icons-home-siding-paneling.gif"
      alt="Home Siding / Paneling"
    />
  ),

  hvac: <IconImg src="/assets/icons/categories/icons-hvac.gif" alt="HVAC / Mini-Splits" />,

  decks: (
    <IconImg src="/assets/icons/categories/icons-deck-installation.gif" alt="Decks" />
  ),

  basementWaterproofing: (
    <IconImg
      src="/assets/icons/categories/icons-waterproofing.gif"
      alt="Waterproofing"
    />
  ),

  flooring: <IconImg src="/assets/icons/categories/icons-flooring.gif" alt="Flooring" />,

  kitchenCabinetRefacing: (
    <IconImg
      src="/assets/icons/categories/icons-kitchen-cabinet-refacing.gif"
      alt="Kitchen Cabinet Refacing"
    />
  ),

  bathroomRemodeling: (
    <IconImg
      src="/assets/icons/categories/icons-bathroom-remodeling.gif"
      alt="Bathroom Remodeling"
    />
  ),

  exteriorDoorReplacement: (
    <IconImg
      src="/assets/icons/categories/icons-exterior-door-replacement.gif"
      alt="Windows & Doors"
    />
  ),

  concreteFoundation: (
    <IconImg
      src="/assets/icons/categories/icons-foundation-repair.gif"
      alt="Concrete/Foundation"
    />
  ),

  foundationRepair: (
    <IconImg
      src="/assets/icons/categories/icons-foundation-repair.gif"
      alt="Foundation"
    />
  ),

  concreteFloorCoating: (
    <IconImg
      src="/assets/icons/categories/icons-concrete-sealing-coating.gif"
      alt="Driveway / Patio Resurfacing"
    />
  ),

  // AUTO-GENERATED CATEGORY ICONS START
  ADUs: (
    <IconImg
      src="/assets/icons/categories/icons-ADUs.gif"
      alt="ADUs"
    />
  ),

  arboristTreeServices: (
    <IconImg
      src="/assets/icons/categories/icons-arborist-tree-services.gif"
      alt="Tree Services"
    />
  ),

  concrete: (
    <IconImg
      src="/assets/icons/categories/icons-concrete-sealing-coating.gif"
      alt="Concrete"
    />
  ),

  electrical: (
    <IconImg
      src="/assets/icons/categories/icons-electrical.gif"
      alt="Electrical"
    />
  ),

  gates: (
    <IconImg
      src="/assets/icons/categories/icons-gates.gif"
      alt="Fence/Gates"
    />
  ),

  homeSidingPaneling: (
    <IconImg
      src="/assets/icons/categories/icons-home-siding-paneling.gif"
      alt="Home Siding Paneling"
    />
  ),

  hvac: (
    <IconImg
      src="/assets/icons/categories/icons-hvac.gif"
      alt="Hvac"
    />
  ),

  junkRemoval: (
    <IconImg
      src="/assets/icons/categories/icons-junk-removal.gif"
      alt="Junk Removal"
    />
  ),

  landscaping: (
    <IconImg
      src="/assets/icons/categories/icons-landscaping.gif"
      alt="Landscaping"
    />
  ),

  plumbing: (
    <IconImg
      src="/assets/icons/categories/icons-plumbing.gif"
      alt="Plumbing"
    />
  ),

  poolMaintenance: (
    <IconImg
      src="/assets/icons/categories/icons-pool-maintenance.gif"
      alt="Pool Service"
    />
  ),

  pools: (
    <IconImg
      src="/assets/icons/categories/icons-pools.gif"
      alt="Pools"
    />
  ),

  rainGutters: (
    <IconImg
      src="/assets/icons/categories/icons-rain-gutters.gif"
      alt="Rain Gutters"
    />
  ),

  roofing: (
    <IconImg
      src="/assets/icons/categories/icons-roofing.gif"
      alt="Roofing"
    />
  ),

  waterHeaters: (
    <IconImg
      src="/assets/icons/categories/icons-water-heaters.gif"
      alt="Water Heaters"
    />
  ),
  // AUTO-GENERATED CATEGORY ICONS END

  fenceGates: (
    <IconImg src="/assets/icons/categories/icons-fence-install.gif" alt="Fence/Gates" />
  ),

  fences: (
    <IconImg src="/assets/icons/categories/icons-fence-install.gif" alt="Fence" />
  ),

  standbyGenerators: (
    <IconImg
      src="/assets/icons/categories/icons-standby-generators.gif"
      alt="Backup Generator Install"
    />
  ),

  waterTreatmentSystems: (
    <IconImg
      src="/assets/icons/categories/icons-water-treatment-systems.gif"
      alt="Ozone Water Treatment Systems"
    />
  ),

  sunroomsAndEnclosures: (
    <IconImg
      src="/assets/icons/categories/icons-sunrooms-and-enclosures.gif"
      alt="Sunrooms & Enclosures"
    />
  ),
};
